import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsal,
} from "@azure/msal-react";
import styled from "styled-components";
import Footer from "./Footer";
import Header from "./Header";
import Sidebar from "./Sidebar";
import { useEffect, useState } from "react";
import { loginRequest } from "../config/msalConfig";
import { InteractionStatus } from "@azure/msal-browser";
import { App } from "antd";
import { motion } from "framer-motion";

import InviteSignupNotice from "./InviteSignupNotice";

export const PageLayout = (props) => {
  // const { instance, inProgress } = useMsal();
  // let activeAccount;

  // if (instance) {
  //     activeAccount = instance.getActiveAccount();
  // }

  // useEffect(() => {
  //   if(!activeAccount && inProgress === InteractionStatus.None){
  //     instance.loginRedirect(loginRequest).catch((error) => console.log(error));
  //   }
  // }, [inProgress, instance, activeAccount]);

  // Track sidebar collapse state for responsive layout
  const [sidebarWidth, setSidebarWidth] = useState(() => {
    const saved = localStorage.getItem("sidebarCollapsed");
    return saved === "true" ? 80 : 270;
  });

  useEffect(() => {
    // Listen for sidebar toggle events
    const handleSidebarToggle = (event) => {
      const { isCollapsed } = event.detail;
      setSidebarWidth(isCollapsed ? 80 : 270);
    };

    window.addEventListener("sidebarToggle", handleSidebarToggle);
    return () => window.removeEventListener("sidebarToggle", handleSidebarToggle);
  }, []);

  return (
    <>
      <AuthenticatedTemplate>
        <div className="flex flex-col min-h-screen gap-0 overflow-x-hidden">
          <App>
            <InviteSignupNotice />
            <Header />
            <div className="flex flex-row w-full min-h-[calc(100vh-80px)] mt-[77px] flex-grow">
              <Sidebar />
              <motion.div
                initial={false}
                animate={{ marginLeft: sidebarWidth + 30 }}
                transition={{ duration: 0.3, ease: "easeInOut" }}
                className="flex flex-col flex-grow overflow-x-hidden"
              >
                {/* Main content */}
                <div className="flex-grow overflow-y-auto overflow-x-hidden">
                  {props.children}
                </div>

                {/* Footer */}
                <div className="mt-auto">
                  <Footer />
                </div>
              </motion.div>
            </div>
          </App>
        </div>
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <App>
          <div className="flex flex-col min-h-screen gap-0 mx-20">
            <div className="flex flex-row w-full h-full gap-2 flex-grow ">
              {props.children}
            </div>
          </div>
        </App>
      </UnauthenticatedTemplate>
    </>
  );
};

export default PageLayout;
